/* eslint-disable max-len */
import { types as coreTypes } from '@sitebuilder/core';

export const defaultPalettes: coreTypes.Palettes = {
    pieChartPalette: {
        '01': {
            hex: '#00a758',
            rgb: 'rgb(0,167,88)',
            cmyk: 'cmyk(100%,34.509803921568626%,65.49019607843137%,34.509803921568626%)',
            spot: 'null',
        },
        '02': {
            hex: '#0000c1',
            rgb: 'rgb(0,0,193)',
            cmyk: 'cmyk(100%,100%,24.31372549019608%,24.31372549019608%)',
            spot: 'null',
        },
        '03': {
            hex: '#ec6453',
            rgb: 'rgb(236,100,83)',
            cmyk: 'cmyk(7.4509803921568585%,60.7843137254902%,67.45098039215686%,7.4509803921568585%)',
            spot: 'null',
        },
        '04': {
            hex: '#260b42',
            rgb: 'rgb(38,11,66)',
            cmyk: 'cmyk(85.09803921568627%,95.68627450980392%,74.11764705882354%,74.11764705882354%)',
            spot: 'null',
        },
        '05': {
            hex: '#ce7612',
            rgb: 'rgb(206,118,18)',
            cmyk: 'cmyk(19.215686274509803%,53.72549019607843%,92.94117647058823%,19.215686274509803%)',
            spot: 'null',
        },
        '06': {
            hex: '#08a298',
            rgb: 'rgb(8,162,152)',
            cmyk: 'cmyk(96.86274509803921%,36.47058823529412%,40.3921568627451%,36.47058823529412%)',
            spot: 'null',
        },
        '07': {
            hex: '#c14836',
            rgb: 'rgb(193,72,54)',
            cmyk: 'cmyk(24.31372549019608%,71.76470588235294%,78.82352941176471%,24.31372549019608%)',
            spot: 'null',
        },
        '08': {
            hex: '#2d69ff',
            rgb: 'rgb(45,105,255)',
            cmyk: 'cmyk(82.35294117647058%,58.82352941176471%,0%,0%)',
            spot: 'null',
        },
        '09': {
            hex: '#004427',
            rgb: 'rgb(0,68,39)',
            cmyk: 'cmyk(100%,73.33333333333334%,84.70588235294117%,73.33333333333334%)',
            spot: 'null',
        },
        '10': {
            hex: '#8877ab',
            rgb: 'rgb(136,119,171)',
            cmyk: 'cmyk(46.666666666666664%,53.333333333333336%,32.94117647058824%,32.94117647058824%)',
            spot: 'null',
        },
        '11': {
            hex: '#fcc457',
            rgb: 'rgb(252,196,87)',
            cmyk: 'cmyk(1.17647058823529%,23.13725490196078%,65.88235294117646%,1.17647058823529%)',
            spot: 'null',
        },
    },
    barChartPalette: {
        '01': {
            hex: '#a62dae',
            rgb: 'rgb(166,45,174)',
            cmyk: 'cmyk(34.90196078431372%,82.35294117647058%,31.76470588235294%,31.76470588235294%)',
            spot: 'null',
        },
        '02': {
            hex: '#1fbbdb',
            rgb: 'rgb(31,187,219)',
            cmyk: 'cmyk(87.84313725490196%,26.66666666666667%,14.117647058823534%,14.117647058823534%)',
            spot: 'null',
        },
        '03': {
            hex: '#df210c',
            rgb: 'rgb(223,33,12)',
            cmyk: 'cmyk(12.549019607843137%,87.05882352941177%,95.29411764705881%,12.549019607843137%)',
            spot: 'null',
        },
        '04': {
            hex: '#e10505',
            rgb: 'rgb(225,5,5)',
            cmyk: 'cmyk(11.764705882352944%,98.0392156862745%,98.0392156862745%,11.764705882352944%)',
            spot: 'null',
        },
        '05': {
            hex: '#ce7612',
            rgb: 'rgb(206,118,18)',
            cmyk: 'cmyk(19.215686274509803%,53.72549019607843%,92.94117647058823%,19.215686274509803%)',
            spot: 'null',
        },
        '06': {
            hex: '#cde802',
            rgb: 'rgb(205,232,2)',
            cmyk: 'cmyk(19.6078431372549%,9.019607843137257%,99.2156862745098%,9.019607843137257%)',
            spot: 'null',
        },
        '07': {
            hex: '#d68a9d',
            rgb: 'rgb(214,138,157)',
            cmyk: 'cmyk(16.07843137254902%,45.88235294117647%,38.431372549019606%,16.07843137254902%)',
            spot: 'null',
        },
        '08': {
            hex: '#e5a02a',
            rgb: 'rgb(229,160,42)',
            cmyk: 'cmyk(10.196078431372547%,37.254901960784316%,83.52941176470588%,10.196078431372547%)',
            spot: 'null',
        },
        '09': {
            hex: '#004427',
            rgb: 'rgb(0,68,39)',
            cmyk: 'cmyk(100%,73.33333333333334%,84.70588235294117%,73.33333333333334%)',
            spot: 'null',
        },
        '10': {
            hex: '#0c20bb',
            rgb: 'rgb(12,32,187)',
            cmyk: 'cmyk(95.29411764705881%,87.45098039215686%,26.66666666666667%,26.66666666666667%)',
            spot: 'null',
        },
        '11': {
            hex: '#13ae7b',
            rgb: 'rgb(19,174,123)',
            cmyk: 'cmyk(92.54901960784314%,31.76470588235294%,51.764705882352935%,31.76470588235294%)',
            spot: 'null',
        },
    },
};
